
export const UserRoles = Object.freeze({
    OEM:   { label: "oem", description: "e-Magic Inc" },
    ADMIN:  { label: "admin", description: "Site Admin" },
    OPERATOR: { label: "operator", description: "Operators" },
    USER: { label: "user", description: "ESB Users" }
  });